import { render, staticRenderFns } from "./FileUploads.vue?vue&type=template&id=a2fc75ea&scoped=true"
import script from "./FileUploads.vue?vue&type=script&lang=js"
export * from "./FileUploads.vue?vue&type=script&lang=js"
import style0 from "./FileUploads.vue?vue&type=style&index=0&id=a2fc75ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fc75ea",
  null
  
)

export default component.exports